var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0605 21.471L22.0671 21.3829C23.0345 21.2983 23.5183 21.256 23.7673 21.0309C23.9842 20.8349 24.1045 20.5537 24.0964 20.2614C24.0871 19.9259 23.7836 19.5469 23.1765 18.7888L19.784 14.5528C19.2824 13.9265 19.0316 13.6133 18.742 13.5219C18.4888 13.4419 18.2142 13.4659 17.9788 13.5886C17.7094 13.729 17.5168 14.081 17.1316 14.7849L16.4875 15.9618M21.0605 21.471L12.4379 11.0831C11.942 10.4857 11.694 10.187 11.4093 10.0993C11.1602 10.0226 10.891 10.0461 10.659 10.165C10.3938 10.3008 10.2015 10.638 9.81688 11.3125L4.6418 20.3871C4.1518 21.2463 3.9068 21.676 3.95224 22.0115C3.99181 22.3036 4.15831 22.5635 4.40724 22.7215C4.69307 22.903 5.18576 22.8598 6.17113 22.7736L21.0605 21.471ZM21.7456 6.35375C21.89 8.0043 20.669 9.4594 19.0185 9.6038C17.3679 9.74821 15.9128 8.52723 15.7684 6.87668C15.624 5.22614 16.845 3.77104 18.4955 3.62663C20.1461 3.48223 21.6012 4.7032 21.7456 6.35375Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_1251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.302734 2.20691) rotate(-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg);
export default __webpack_public_path__ + "static/media/cardImg.76aca8f26676fdec3ff195286d13f6d3.svg";
export { ForwardRef as ReactComponent };